module.exports = __webpack_public_path__ + "static/media/hiking.a4ea3850.svg";